import FileSecurityFeatureList from './FileSecurityFeatureList.component';

export default FileSecurityFeatureList;
